export const deepFreeze = <T extends object & Record<string, any>>(object: T): Readonly<T> => {
  Object.freeze(object);

  const props = Object.getOwnPropertyNames(object);

  for (let i = 0; i < props.length; i++) {
    const prop = props[i];
    if (
      object.hasOwnProperty(prop) &&
      object[prop] !== null &&
      (typeof object[prop] === 'object' || typeof object[prop] === 'function') &&
      !Object.isFrozen(object[prop])
    ) {
      deepFreeze(object[prop]);
    }
  }

  return object;
};
